<template>
  <v-slide-y-transition mode="out-in">      
    <div>
      <v-tabs      
        dark v-model="active"
        v-bind:color="kompetisi ? kompetisi.color : 'black'"
        show-arrows      
      >    
        <v-tabs-slider color="yellow"></v-tabs-slider>      
        <v-tab v-for="(item, i) in tabs" :key="i">{{item.name}}</v-tab>            
        <v-tabs-items>
          <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>    
          <v-tab-item v-for="(item, i) in tabs" :key="i">
            <v-card flat>            
              <v-card-text>
                <v-card v-if="kompetisi">
                  <v-toolbar>
                    <v-text-field
                      flat
                      solo
                      append-icon="search"
                      placeholder="Type something"
                      v-model="item.areaSearch"
                      hide-details
                    ></v-text-field>
                    <v-tooltip bottom>
                      <v-btn slot="activator" :loading="loading" icon @click="refreshKompetisi(i)">
                        <v-icon>refresh</v-icon>            
                      </v-btn>
                      <span>Refresh</span>
                    </v-tooltip>                   
                    <v-spacer></v-spacer>            
                    <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
                      <v-switch v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
                      ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
                    </v-chip>
                  </v-toolbar>
                  <template v-if="!item.areaSearch && item.show">
                    <v-card-text class="pa-1">
                      <v-layout row wrap>
                        <v-flex lg6 sm6 xs12 class="pa-2">                        
                          <!--<template v-if="i === 0">
                            <e-chart :key="'a'+moment" v-if="!quickcountMode" v-bind:option="setPieOption(kompetisi)" height="250px" width="100%"/>                  
                            <e-chart :key="'b'+moment" v-else v-bind:option="setPieOption(kompetisi, true)" height="250px" width="100%"/>                                                         
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left"><span class="title blue--text"><v-icon color="blue">accessibility</v-icon> {{kompetisi.sah.sah?kompetisi.sah.sah:0}}</span>/<small>{{kompetisi.pt?kompetisi.pt:0}} &nbsp; telah memilih</small></td>
                                <td class="text-xs-right"><small>tidak sah </small><span class="title red--text">{{kompetisi.sah.tdk_sah?kompetisi.sah.tdk_sah:0}}  <v-icon color="red">layers_clear</v-icon></span></td>
                              </tr>                        
                            </table>            
                            <v-divider></v-divider>
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left"><span class="subheading" :class="colorPersen(persenContain(kompetisi.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(kompetisi.contain))">trending_up</v-icon> {{persenContain(kompetisi.contain)}}% </span> to complete</td></td>
                                <td class="text-xs-right"><v-chip :color="item.color" small dark>
                                  <v-avatar><v-icon small>alarm</v-icon></v-avatar>
                                  <small>{{kompetisi.sah.updated_at?$moment(kompetisi.sah.updated_at*1000).fromNow():null}}</small></v-chip></td></td>
                              </tr>                        
                            </table>     
                          </template>-->
                          <template>
                            <e-chart :key="'a'+(item.time+item.id)" v-if="!quickcountMode" v-bind:option="setPieOption(item)" height="250px" width="100%" />                  
                            <e-chart :key="'b'+(item.time+item.id)" v-else v-bind:option="setPieOption(item, true)" height="250px" width="100%"/>                                                                                   
                            <table style="width:100%" v-if="!quickcountMode">
                              <tr>
                                <td class="text-xs-left"><span class="title blue--text"><v-icon color="blue">accessibility</v-icon> {{item.sah.sah?item.sah.sah:0}}</span>/<small>{{item.pt?item.pt:0}} &nbsp; telah memilih</small></td>
                                <td class="text-xs-right"><small>tidak sah </small><span class="title red--text">{{item.sah.tdk_sah?item.sah.tdk_sah:0}}  <v-icon color="red">layers_clear</v-icon></span></td>
                              </tr>                        
                            </table>            
                            <v-divider></v-divider>
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left"><span class="subheading" :class="colorPersen(persenContain(item.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(item.contain))">trending_up</v-icon> {{persenContain(item.contain)}}% </span> to complete</td></td>
                                <td class="text-xs-right"><v-chip :color="item.color" small dark>
                                  <v-avatar><v-icon small>alarm</v-icon></v-avatar>
                                  <small>{{item.sah.updated_at?$moment(item.sah.updated_at*1000).fromNow():null}}</small></v-chip></td></td>
                              </tr>                        
                            </table>     
                          </template>
                        </v-flex>
                        <v-flex lg6 sm6 xs12 class="tabular">
                          <v-data-table style="max-height: 330px; overflow-y: auto"
                            :headers="[                            
                              {text:'No',sortable:false,value:'no',align:'center'},
                              {text:'',value:'i',sortable:false},{ text: 'Rank Sementara', value:'value'},
                              {text:'Suara',sortable:false,value:'value'}
                            ]"
                            :items="item.calons"  
                            :pagination.sync="pagination"
                            hide-actions
                            >
                            <template slot="items" slot-scope="props"> 
                              <tr>                              
                                <td>
                                  <v-chip :color="props.item.color" dark>{{props.item.no}}</v-chip>                                  

                                </td>
                                <td>
                                  <v-avatar size="70">
                                    <img :src="props.item.thumb ? props.item.thumb :require('@/assets/img/avatar/blank-dpd.jpg')">
                                  </v-avatar>
                                </td>
                                <td>                                
                                    <v-list-tile-title v-html="props.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="props.item.tagline"></v-list-tile-sub-title>
                                </td>     
                                <td><span class="subheading">{{props.item.value?props.item.value:0}}</span></td>
                              </tr>
                            </template>
                          </v-data-table>                                                
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </template>  
                </v-card>  
                <v-container grid-list-lg fluid pa-0 mt-3 pb-3>
                  <v-layout row wrap>
                    <v-flex lg4 sm6 xs12 v-for="(data) in tabs[i].area.data" v-if="data.is_author">
                      <!--<router-link v-if="data.tingkat==5" v-bind:to="{path:'/hitung/form', query: {
                          kompetisi_id : $route.query.kompetisi_id,
                          mode : kompetisi.mode,
                          tps_id : data.id, 
                      }}">
                        <v-card class="cursor">
                          <v-card-text>
                            <div class="layout row ma-0 align-center justify-space-between">
                              <div class="text-box">
                                <div class="caption pb-2">{{data.name}}</div>                              
                                <!--<span class="grey--text">{{data.contain.done}} <v-icon small color="green">trending_up</v-icon> {{data.contain.all}} TPS</span>
                              </div>
                              <div class="chart">
                                <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value="persenContain(data.contain)"
                                    :color="data.tpsSah.sah? 'success':'warning'"
                                  >                                  
                                    <span v-if="persenContain(data.contain)==100">
                                        <v-icon color="success" v-if="data.tpsSah.sah">check_circle</v-icon>
                                        <v-icon color="warning" v-else>fast_forward</v-icon>
                                    </span>
                                    <v-icon v-else>history</v-icon>
                                  </v-progress-circular>

                              </div>
                            </div>
                          </v-card-text>
                        </v-card>             
                      <!--</router-link>-->
                      <v-card class="cursor elevation-3" @click="newTab(data,i+1)">
                        <v-card-text class="pa-0">
                          <div class="layout row ma-0 align-center justify-space-between">
                            <div class="text-box pa-3">
                              <div class="subheading pb-2"><strong>{{data.name}}</strong></div>                             
                            </div>
                            <div class="chart mr-2">
                              <e-chart :key="'c'+item.time" v-if="!quickcountMode" v-bind:option="setPieOption2(data)" height="150px" width="150px"/>                  
                              <e-chart :key="'d'+item.time" v-else v-bind:option="setPieOption2(data, true)" height="150px" width="150px"/>                                                                                   
                            </div>                          
                          </div>
                          <v-flex xs12 pt-0 mt-0 mb-0 pb-0>
                            <table style="width:100%; margin-top: -20px" v-if="!quickcountMode">
                              <tr>
                                <td class="text-xs-left"><span class="caption indigo--text"><v-icon small color="indigo">accessibility</v-icon> {{data.sah.sah?data.sah.sah:0}}</span>/<small>{{data.pt?data.pt:0}}</small></td>
                                <td class="text-xs-right"><span class="caption red--text">{{data.sah.tdk_sah?data.sah.tdk_sah:0}}  <v-icon small color="red">layers_clear</v-icon></span></td>
                              </tr>                        
                            </table>            
                            <v-divider></v-divider>
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left">
                                  <span class="caption" :class="colorPersen(persenContain(data.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(data.contain))">trending_up</v-icon> {{persenContain(data.contain)}}% </span> &nbsp;
                                  <span class="caption blue--text"><v-icon small color="blue">store</v-icon> {{data.contain?quickcountMode?data.contain.quick:data.contain.done:0}}</span>/<small>{{data.contain?data.contain.all:0}} tps</small>
                                </td>
                                <td class="text-xs-right">                                
                                  <small>{{data.sah.updated_at?$moment(data.sah.updated_at*1000).fromNow():null}}</small>&nbsp;
                                  <v-icon small>alarm</v-icon>
                                </td>
                              </tr>                        
                            </table>
                          </v-flex>
                        </v-card-text>
                      </v-card>             
                    </v-flex>
                    <v-flex lg4 sm6 xs12 v-if="tabs[i].area.data.length < tabs[i].area.count">
                      <v-btn class="my-0" block color="info" :loading="loading" small dark @click="setAreas(tabs[i])">load more ...</v-btn>
                    </v-flex>  
                  </v-layout> 
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <form-dialog :dialog="dialog" :cekup="cekup" v-on:closeDialog="closeDialog($event)"></form-dialog>
    </div>  
  </v-slide-y-transition>
</template>

<script>  
import EChart from '@/components/chart/echart';    
import DPie   from '../../components/data-chart/pie-1';
import DPie2  from '../../components/data-chart/pie-2';
import Model  from '@/apps/frc/models/Dashboard';
import FormDialog from './dialog';
const  model = new Model();

export default {    
    components: {
      EChart,
      FormDialog
    },
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
      tabs : [],
      active : 0,
      search : [], 
      kompetisi_id : null,
      kompetisi : null,                      
      formPath : '/kompetisi/form',      
      loading  : true,
      pagination : {'sortBy': 'value', 'descending': true, 'rowsPerPage': -1},      
      quickcountMode : false,      
      maxvalue: 0,
      dialog : false,
      cekup  : {
        kompetisi_id : null,
        tps_id : null,
        mode : null,
      } 
    }),     
    watch:{      
    },
    asyncComputed:{
      back(){
        if(this.$route.query.area_ids){
          let a_ids = this.$route.query.area_ids;
          let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
          if((this.tabs.length-1) > area_ids.length){
            this.active = (area_ids.length);          
          }
        } else {
          this.active = 0;
        }
        return true;
      }
    },
    mounted(){ this.init() },        
    created () {},
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},                
        
        resize(){
            setTimeout(function(){
              window.getApp.$emit('RESIZE-ECHART');
            },100);            
        },
        
        closeDialog(e){
          this.dialog = e.dialog;
          this.cekup  = e.cekup;             
        },
        
        init(){                      
          if(this.kompetisi_id !== this.$route.query.kompetisi_id){
            this.loading = true;            
            this.kompetisi_id = this.$route.query.kompetisi_id;
            model.kompetisi({id:this.$route.query.kompetisi_id}).then(res=>{                  
                let index = 0;                 
                this.kompetisi = res.data;                       
                this.newTab(res.data,index);

                if(this.$route.query.area_ids){   
                    this.loading = true;
                    let a_ids = this.$route.query.area_ids;
                    let t_ids = this.$route.query.tingkat_ids;                      
                    let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
                    let tingkat_ids = Array.isArray(t_ids) ? t_ids : [t_ids];

                    let arr = this.urutkan(tingkat_ids, area_ids);                      
                    this.setTabs(arr);                                           
                } 
            });
          }                                        
        },
        
        newTab(data, i){
            if(data.tingkat < 5){   
                for(let j=this.tabs.length; j >= i ; j--){
                    this.tabs.splice(j, 1);                    
                }
                
                if(!this.tabs[i]){                    
                    this.tabs.push({name:data.name, calons:data.calons, area_ids:[],show:false , tingkat_ids:[],areaSearch:null, area:{data:[], count:0, page:1, time:null}});                                 
                    let ctx= this; setTimeout(function(){ctx.tabs[i].show= true;},100);
                }                   
                
                Object.assign(this.tabs[i], data);                
                this.$watch(['tabs',i,'areaSearch'].join('.'), (val)=>{ 
                    const ctx = this; setTimeout(function(){
                       if(val === ctx.tabs[i].areaSearch){
                          ctx.setAreas(ctx.tabs[i], true); 
                       }
                    }, 700);                    
                });
                
                this.setAreas(this.tabs[i], true);
                this.setCalons(i);
                this.active = i;                                
                
                if(i > 0){
                  
                  
                  var area_ids = []; var tingkat_ids = []; 
                  for(let j=1; j<this.tabs.length; j++){
                      area_ids.push(this.tabs[j].area_id);
                      tingkat_ids.push(this.tabs[j].tingkat);
                  }
                  this.hitungRoute(area_ids, tingkat_ids); 
                }        
                
                
            } else {
              if(data.sah && data.sah.sah > 0){
                this.showDialog(this.kompetisi.id, data.id, this.kompetisi.mode);
              } else {
                window.getApp.$emit('showSnackbar', {
                    show : true,text : 'No Data Result', color: 'warning'
                });
              }
              //this.formRoute(data.id);                
            }
        },
        
        showDialog(kompetisi_id, tps_id, mode){                        
            Object.assign(this.cekup, {kompetisi_id : kompetisi_id, tps_id:tps_id, mode:mode});
            this.dialog = true;
        },
        
        setCalons(i){ 
            this.tabs[i].calons.forEach((item, j)=>{                
                var value = this.quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                this.tabs[i].calons[j].value = value;                
            });
            
        },
        
        refreshKompetisi(i){          
          let fm = this.tabs[i];          
          this.loading =true;
          if(i > 0){
            model.areas({tingkat:fm.tingkat,'AreaSearch[id]':fm.area_id,kompetisi_id:this.$route.query.kompetisi_id}).then(res=>{
                Object.assign(fm, res.data.data[0]);
                this.setCalons(i);
                this.setAreas(fm, true);
            });
          } else {
            model.kompetisi({id:this.$route.query.kompetisi_id,tingkat:fm.tingkat,area_id:fm.area_id}).then(res=>{                  
                Object.assign(fm, res.data);
                this.setCalons(i);
                this.setAreas(fm, true);            
            });
          }
        },
        
        async setTabs(arr){
            var index = 1;
            for(var i in arr){
                let res = await model.areas({tingkat:arr[i].a,'AreaSearch[id]':arr[i].b,kompetisi_id:this.kompetisi_id});
                this.newTab(res.data.data[0], index++);                
            }
        },                
          
        persenContain(contain){
            return this.quickcountMode?(contain.quick/contain.all*100).toFixed(2):(contain.done/contain.all*100).toFixed(2);
        },

        colorPersen(persen){
            if(persen >= 0 && persen <=40)return 'red';
            else if(persen <=60)return 'orange';
            else if(persen <=80)return 'yellow';
            else if(persen <=99)return 'blue';
            else return 'green';        
        },
        
        firstLetter (name) {
            return name.charAt(0);
        },                
        
        setAreas(fm, reset = false){            
            this.loading = true;    
            if(!fm) return;
            if(reset) fm.area.page = 1;
            model.areas({tingkat: (parseInt(fm.tingkat) + 1), kompetisi_id:this.kompetisi_id,'AreaSearch[parent_id]':fm.area_id, page:fm.area.page, 'AreaSearch[name]':fm.areaSearch}).then(resp=>{
                if(reset) {fm.area.data = []; fm.area.page = 1;}                
                fm.area.data    = [...fm.area.data, ...resp.data.data];                
                fm.area.page++;
                fm.area.count = resp.data.count; 
                fm.area.time  = resp.data.time; 
                if(reset && fm.area.data.length == 0) {fm.area.page = 1;}
                this.loading = false;
            });
        },                                
        
        setPieOption(data, quickcountMode=false){
            //let ctx = this; setTimeout(function(){
          
            let newOption  = JSON.parse(JSON.stringify(DPie.option));
            let seriesData = [], legendData = [];        
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value > 0 ? value :null;
                var name  = item.no+'. '+item.akronim;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(name);                
            });
            newOption.series[0].data = seriesData;      
            newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
            
            //}, 500);
        },
        
        setPieOption2(data, quickcountMode=false){            
            let newOption  = JSON.parse(JSON.stringify(DPie2.option));
            let seriesData = [], legendData = []; this.calons = [];        
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara;   
                value = value > 0 ? value :null;
                var name  = item.no+'. '+item.akronim;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(name);                
            });
            newOption.series[0].data = seriesData;      
            newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
        },
        
        areaRoute (id, tingkat) {
            this.$router.push({path:'/dashboard/explore', query: {kompetisi_id: id, tingkat: tingkat}});
        },                
        
        formRoute(tps_id){
            let q = this.$route.query;
            this.$router.push({path:'/hitung/form', query: {
                kompetisi_id : q.kompetisi_id,
                mode : this.kompetisi.mode,
                tps_id : tps_id, 
            }});
        },
        
        hitungRoute(area_ids, tingkat_ids){
            let q = this.$route.query;
            this.$router.push({path:'/dashboard/explore', query: {
                kompetisi_id : q.kompetisi_id,
                mode : q.mode,
                tingkat : q.tingkat,
                area_ids : area_ids,
                tingkat_ids : tingkat_ids,                
            }});
        },
        
        urutkan(arrA, arrB){
            for(var i=0; i<arrA.length; i++){
              for(var j=i+1; j<arrA.length; j++){
                if(arrA[i]>arrA[j]){
                    var tmpA=arrA[i]; var tmpB=arrB[i]; 
                    arrA[i]=arrA[j];  arrB[i]=arrB[j];
                    arrA[j]=tmpA;     arrB[j]=tmpB;
                }     
              }   
            }
            var result = [];
            for(var i=0; i<arrA.length; i++){
              result.push({a:arrA[i], b:arrB[i]});
            }            
            return result;            
        }
    }
}
</script>
  
